import { useState } from 'react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { parseError } from '@/lib/errors'
import {
  type PolicyChangeAsk,
  type PolicyChangeReply,
  type PolicyChangeRequest,
  policyChangeWrites,
  usePolicyChangeMutation,
} from '@/models/policyChange'
import { AskReplyFields } from './AskReplyFields'

/** The customer's answer to a question that leaves the request on its step: a note, files, or both. */
export function AskReplyForm({
  orgId,
  request,
  ask,
}: {
  orgId: string | undefined
  request: PolicyChangeRequest
  ask: PolicyChangeAsk
}) {
  const answer = usePolicyChangeMutation(orgId, policyChangeWrites.answer)
  const [reply, setReply] = useState<PolicyChangeReply>({ reply: '', files: [] })
  const ready = ask.needsDocument
    ? reply.files.length > 0
    : reply.reply.trim() !== '' || reply.files.length > 0

  function send() {
    answer.mutate(
      { requestId: request.id, askId: ask.id, ...reply },
      {
        onSuccess: () => toast.success('Sent to your insurance broker.'),
        onError: (error) => toast.error(parseError(error)),
      }
    )
  }

  return (
    <>
      <AskReplyFields
        id={`ask-${ask.id}`}
        value={reply}
        onChange={setReply}
        needsDocument={ask.needsDocument}
        replyOptional={ask.needsDocument}
      />
      <div>
        <Button disabled={!ready} onClick={send} loading={answer.isPending ? 'Sending…' : undefined}>
          Send
        </Button>
      </div>
    </>
  )
}
